/**
 * useSystemSettings
 * The custom hook which provided to external use via context
 */

import { useContext } from 'react'

import SystemSettingsContext from './system-settings-context'

const useSystemSettings = () => {
  const context = useContext(SystemSettingsContext)
  return context
}

export default useSystemSettings
